// extracted by mini-css-extract-plugin
module.exports = {"muted":"Details_muted___iuO7","detailsRow":"Details_detailsRow__iYFW4"};